import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Label } from '../../../components/ui/label';

/**
 * Step 1 — Product category grid. Click a card to both select the category
 * and auto-advance to step 2.
 */
export const Step1Category = ({ productData, selectedProduct, setSelectedProduct, setStep }) => (
  <div>
    <Label className="text-lg font-semibold mb-4 block">Category</Label>
    <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
      {productData.categories.map((cat) => (
        <Card
          key={cat.id}
          data-testid={`category-card-${cat.id}`}
          className={`cursor-pointer transition-all duration-300 ease-out hover:shadow-2xl hover:-translate-y-2 group overflow-hidden ${
            selectedProduct === cat.id
              ? 'border-[#6FBF73] border-2 bg-green-50 shadow-lg animate-pulse-ring'
              : 'border-gray-200 hover:border-[#6FBF73] shadow-md'
          }`}
          onClick={() => {
            setSelectedProduct(cat.id);
            setStep(2);
          }}
        >
          <CardContent className="p-5 text-center">
            {cat.image ? (
              <div className="overflow-hidden rounded-lg mb-3 bg-gradient-to-br from-green-50 to-white">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-36 object-cover rounded-lg transition-transform duration-500 ease-out group-hover:scale-110 group-hover:rotate-1"
                />
              </div>
            ) : (
              <div className="text-5xl mb-3 transition-transform duration-300 group-hover:scale-125">{cat.icon}</div>
            )}
            <h3 className="font-bold text-lg text-[#4A7C59] transition-colors duration-300 group-hover:text-[#6FBF73]">
              {cat.name}
            </h3>
            <p className="text-sm text-gray-600 mt-2 transition-all duration-300 group-hover:text-gray-800">
              {cat.description}
            </p>
            <div className="mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <span className="text-xs font-semibold text-[#6FBF73]">Click to explore →</span>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);
